import { render, staticRenderFns } from "./baiduManage.vue?vue&type=template&id=4fb94b3c&scoped=true"
import script from "./baiduManage.vue?vue&type=script&lang=js"
export * from "./baiduManage.vue?vue&type=script&lang=js"
import style0 from "./baiduManage.vue?vue&type=style&index=0&id=4fb94b3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb94b3c",
  null
  
)

export default component.exports